/** "This page does not exist.": an unknown address in the company dashboard or the admin console, and a malformed id
 * (live tests EX-07, EX-10, LT-97). Inside a layout it sits in the page; alone (the editor, the Permit workspace and
 * the Sketch have no sidebar) it fills the window. */
import { SearchX } from "lucide-react";
import type { ReactNode } from "react";
import { Link, Outlet, useParams } from "react-router-dom";
import { useT } from "../i18n/I18nProvider";
import { isUuid } from "../lib/notFound";
import { Empty } from "./ui";

export function NotFound({ admin, standalone }: { admin?: boolean; standalone?: boolean }) {
  const t = useT();
  const body = (
    <Empty
      icon={<SearchX />}
      title={t("shell.notFound.title")}
      action={
        <Link className="btn btn-primary" to={admin ? "/admin/orgs" : "/designs"}>
          {admin ? t("shell.notFound.admin") : t("shell.notFound.home")}
        </Link>
      }
    >
      {t("shell.notFound.body")}
    </Empty>
  );
  return standalone ? <div className="center-fill" style={{ minHeight: "100vh", padding: 16 }}>{body}</div> : body;
}

/** The route's `param` must be a UUID, else the not-found page (nothing is asked of the API). */
export function ValidId({ param, children, admin, standalone }: { param: string; children?: ReactNode; admin?: boolean; standalone?: boolean }) {
  const value = useParams()[param];
  if (!isUuid(value)) return <NotFound admin={admin} standalone={standalone} />;
  return <>{children ?? <Outlet />}</>;
}

